var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__card",style:(`background:${_vm.color};color:${_vm.textColor};border-radius:${_vm.borderRadius}`)},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v("NGN "+_vm._s(_vm.value.toLocaleString("en")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }